














































































































































































































































































import { default as Component } from 'vue-class-component';
import NonCommodityProductWidget from '@/components/widgets/NonCommodityProductWidget.vue';
import ProductInfoWidget from './ProductInfoWidget.vue';
import ProductData from '@/interfaces/ProductData';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Api from '@/interfaces/Api';
import { Watch } from 'vue-property-decorator';
import Tracking from '@/interfaces/Tracking';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);
const trackingProvider = IocContainer.get<Tracking>(SERVICES.TRACKING);

@Component({
  components: {
    'product-info': ProductInfoWidget
  }
})
export default class ProductWidget extends NonCommodityProductWidget {
  protected initializedProducts = false;
  public customerType: string = '';
  public vehicleType: string = '';

  @Watch('isSessionLoaded')
  protected onSessionLoaded(): void {
    if (this.isSessionLoaded && !this.initializedProducts) {
      this.pickCustomerType();
    }
  }

  private pickCustomerType(): void {
    this.initializedProducts = true;
    this.initializeCustomerType();
    if (this.isCustomerTypeBusiness) {
      this.setCustomerTypeBusiness();
    } else {
      this.setCustomerTypePrivate();
    }
  }

  public mounted(): void {
    if (this.isSessionLoaded && !this.initializedProducts) {
      this.pickCustomerType();
    }
  }

  get productHeader(): string {
    if (this.isFleetFlow) {
      return this.$t('noncommodity.product.header.fleet').toString();
    }
    return this.$t('noncommodity.product.header').toString();
  }

  get productDescription(): string {
    if (this.isFleetFlow) {
      return this.$t('noncommodity.product.description.fleet', { year: this.thgConfig.selectedYear }).toString();
    }
    return this.$t('noncommodity.product.description').toString();
  }

  private initializeCustomerType(): void {
    if (this.currentClient === 'elli-thg-man') {
      this.thgConfig.setCustomerTypeBusiness();
      this.customerType = this.thgConfig.keyCustomerTypeBusiness;
    } else {
      this.thgConfig.customerType = this.thgConfig.keyCustomerTypeNone;
    }
    if (typeof this.sessionState.business != 'undefined') {
      if (this.sessionState.business == 1) {
        this.thgConfig.setCustomerTypeBusiness();
      } else {
        this.thgConfig.setCustomerTypePrivate();
      }
    }
  }

  public get isCustomerTypePrivate(): boolean {
    return this.customerType == this.thgConfig.keyCustomerTypePrivate;
  }

  public get isCustomerTypeBusiness(): boolean {
    return this.customerType == this.thgConfig.keyCustomerTypeBusiness;
  }

  public get isCustomerTypeSelected(): boolean {
    return this.isCustomerTypePrivate || this.isCustomerTypeBusiness;
  }

  public get isVehicleTypeSelected(): boolean {
    return this.vehicleType.length > 0;
  }

  public get showProductSelection(): boolean {
    return this.isCustomerTypePrivate && this.isVehicleTypeSelected;
  }

  public get showProductYearSelection(): boolean {
    return (
      !this.loadingProducts &&
      this.isCustomerTypeSelected &&
      !this.showProductSelection &&
      this.thgConfig.availableYears.length > 1
    );
  }

  public get showVehicleClassSelection(): boolean {
    const hasSelectedYear: boolean =
      this.thgConfig.availableYears.length === 1 ? true : this.thgConfig.selectedYearArray.length > 0;
    return (
      this.isCustomerTypeSelected &&
      !this.loadingProducts &&
      !this.zeroProductsLoaded &&
      !this.showProductSelection &&
      hasSelectedYear
    );
  }

  public get showButtonBack(): boolean {
    return !this.zeroProductsLoaded;
  }

  public get showButtonSubmit(): boolean {
    return !this.zeroProductsLoaded;
  }

  public get canSubmit(): boolean {
    return !this.isSubmitting || this.store.state.nonCommodityProductData.productId == 0;
  }

  get b2cProducts(): ProductData[] {
    return this.products
      .filter(
        (product) =>
          !product.productCode.includes('B2B') &&
          product.elliNonCommodityProcurementPrices?.find(
            (price) => price.classification == this.$store.getters.getSelectedVehicleType && price.brutto
          )
      )
      .sort((a) => {
        if (process.env.VUE_APP_ENVIRONMENT.includes('elli-thg-audi')) {
          return a.productCode.includes('Voucher') ? -1 : 0;
        }
        return a.productCode.includes('Bonus') ? -1 : 0;
      });
  }

  public get zeroProductsLoaded(): boolean {
    return this.products.length == 0;
  }

  public getProductInfoClass(product): string {
    if (process.env.VUE_APP_ENVIRONMENT.includes('elli-thg-audi')) {
      if (product.productCode.includes('Voucher')) {
        return 'non-commodity-product-eco';
      }
      return '';
    }

    if (product.productCode.includes('Bonus')) {
      return 'non-commodity-product-eco';
    }

    return '';
  }

  public deselectVehicleType(): void {
    this.setVehicleType('');
  }

  public closeFleet(): void {
    this.store.commit('SET_IS_FLEET_FLOW', false);
    this.$emit('scrollToTop');
  }

  protected selectBusinessProduct(): void {
    for (let product of this.products) {
      if (product.productCode.toUpperCase().includes('B2B')) {
        this.store.dispatch('setNonCommodityProduct', product);
        this.selectProduct(product);
        this.productSubmit();

        return;
      }
    }
  }

  private emitCustomerTypeChanged(): void {
    this.$emit('customerTypeChanged', this.thgConfig.customerType);
  }

  private emitCustomerTypeSelected(): void {
    this.$emit('customerTypeSelected', this.thgConfig.customerType);
  }

  private updateSessionOnCustomerTypeChange(): void {
    this.emitCustomerTypeChanged();
    ApiProvider.sessionUpdate(this.sessionState)
      .then(() => {
        this.emitCustomerTypeSelected();
        if (typeof this.sessionState.extendedData === 'string') {
          // Before saving to the session, JSON is transformed back into an object
          this.sessionState.extendedData = JSON.parse(this.sessionState.extendedData);
        }
        this.store.commit('SET_SESSION', this.sessionState);
      })
      .catch((error) => {
        if (error.response.status === 422) {
          this.errorsBag = error.response.data.errors;
          this.store.dispatch('setErrors', error.response.data.errors);
        }
        this.$emit('onCustomerTypeChangeError');
      });
  }

  public setCustomerTypeBusiness(): void {
    this.sessionState.business = 1;
    this.thgConfig.setCustomerTypeBusiness();
    this.customerType = this.thgConfig.keyCustomerTypeBusiness;
    this.updateSessionOnCustomerTypeChange();
  }

  public setCustomerTypePrivate(): void {
    this.sessionState.business = 0;
    this.sessionState.company = '';
    this.sessionState.billingCompany = '';
    this.thgConfig.setCustomerTypePrivate();
    this.customerType = this.thgConfig.keyCustomerTypePrivate;
    this.updateSessionOnCustomerTypeChange();
  }

  public setVehicleType(identifier: string): void {
    if (!this.thgConfig.setVehicleType(identifier)) {
      return;
    }
    this.vehicleType = identifier;
    if (this.isCustomerTypeBusiness) {
      this.selectBusinessProduct();
    }
  }

  public fleetSubmit(): void {
    this.isSubmitting = true;
    const data = {
      productCode: 'fleet'
    };
    ApiProvider.sessionUpdate(data)
      .then(() => {
        trackingProvider.thgProductSelected(
          this.selectedProductData,
          this.thgConfig.selectedVehicleTypeIdentifier,
          this.thgConfig.isCustomerTypeBusiness
        );
        this.$emit('productSubmit', data);
        this.isSubmitting = false;
        this.store.dispatch('setNonCommodityProduct', this.selectedProductData);
      })
      .catch((error) => {
        if (typeof error.response !== 'undefined' && error.response.data.error.message === 'session outdated') {
          localStorage.removeItem(process.env.VUE_APP_SESSION_STORAGE_KEY);
          window.location.href = document.referrer || window.location.origin;
        }
        this.isSubmitting = false;
      });
  }
}
